module.exports = __webpack_public_path__ + "b9fd2f3be7d419f4b1c791578ae02605.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/short.png
// module id = 2552
// module chunks = 0